import { DealerID } from "./Dealer";
import { User, UserID } from "./User";

export type AgreementHistoryID = number;

export type AgreementInfoID = number;

export type AgreementVersionID = number;

export interface AgreementHistory {
  created_on: string;
  id: AgreementHistoryID;
  agreement_url: string;
  dealer_id: DealerID;
  user_id: UserID;
  agreement_version_id: AgreementVersionID;
  user?: User;
}

export interface AgreementInfo {
  created_on: string;
  updated_on: string;
  id: AgreementInfoID;
  user_id: UserID;
  dealer_id: DealerID;
  agreement_version_id: AgreementVersionID;
  signed: boolean;
  history?: AgreementHistory[];
  data_officer?: User;
}

export interface AgreementVersion {
  created_on: string;
  updated_on: string;
  agreement_version_id: AgreementVersionID;
  url: string;
}
